<nav role="navigation" [ngClass]="{ 'no-top-border': tabLikeAppearance }" [attr.aria-label]="ariaLabel">
	<div class="container" [ngClass]="{ 'no-left-margin': tabLikeAppearance }">
		<ul>
			@for (item of items; track item) {
				<li>
					@if (item.show && !item.isExternalUrl && !item.isDropdownButton) {
						<a [routerLink]="item.href" routerLinkActive="active" class="{{ item.display }}-navBar">
							<ea-button-link
								tabindex="-1"
								[isActive]="isActivePage(item.href)"
								[name]="item.display"
								[routerLink]="item.href"
								[title]="item.display">
								{{ item.display }}
							</ea-button-link>
						</a>
					}
					@if (item.show && item.isExternalUrl && !item.isDropdownButton) {
						<a [href]="item.href" class="{{ item.display }}-navBar">
							<ea-button-link
								tabindex="-1"
								[isActive]="isActivePage(item.href)"
								[name]="item.display"
								(onClick)="navigateToWebUrl(item.href)"
								[title]="item.display">
								{{ item.display }}
							</ea-button-link>
						</a>
					}
					@if (item.show && item.isDropdownButton) {
						<a class="{{ item.display }}-navBar">
							<ea-button-drop-down
								[attr.aria-current]="isActivePage(item.href) ? 'page' : null"
								tabindex="0"
								[name]="item.display"
								[title]="item.display"
								[dropDownItems]="item.dropdownItems">
								{{ item.display }}
							</ea-button-drop-down>
						</a>
					}
				</li>
			}
		</ul>
		<ng-content></ng-content>
	</div>
</nav>
